import React, { useState } from 'react';
import { json } from 'react-router-dom';
import { useIntl } from 'react-intl';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import {
  Button, Col, Container, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import SelectInput from '../../../components/fields/SelectInput/SelectInput';
import notificationDecorator from '../../Notifications/notificationDecorator';
import Switches from '../../../components/fields/Switches/Switches';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import { PermissionDeniedError } from '../../../utils/utils';

export default function ComponentsPage() {
  const intl = useIntl();
  const { formatMessage } = intl;
  const stateOptions = [
    { value: 0, name: 'Option 1' },
    { value: 1, name: 'Option 2' },
    { value: 2, name: 'Option 3' },
  ];
  const showNotification = () => {
    notificationDecorator({
      title: formatMessage({ id: 'app.password.recovery' }),
      message: formatMessage({ id: 'success' }),
      isError: true,
    });
  };
  const permissionDeniedHandler = () => {
    throw new PermissionDeniedError('Not available');
  };
  const [switchValue, setSwitchValue] = useState(false);
  return (
    <div className="content g-0 pb-4">
      <PageHeader header="Components" />
      <Container className="components-table g-0 mt-4">
        <Row>
          <Col>
            <div className="frame">
              <div className="f4 p-3">Inputs</div>
              <Container className="components-table g-0 px-3 pb-3">
                <Row>
                  <Col>
                    <TextInputWithLabel
                      withLabel
                      label="Text input"
                      autocomplete="new-password"
                      inputAfter={<Icons className="password-icon" icon="eye-fill" />}
                      inputProps={{
                        value: '',
                        onChange: () => {},
                      }}
                      placeholder="Placeholder"
                      variant="material"
                    />
                    <CustomSelectInput
                      withLabel
                      label="Custom select input"
                      autocomplete="new-password"
                      className="mt-3"
                      inputAfter={<Icons className="password-icon" icon="eye-fill" />}
                      options={stateOptions}
                      inputProps={{
                        value: '',
                        onChange: () => {},
                      }}
                      placeholder="Placeholder"
                      variant="material"
                    />
                    <SelectInput
                      withLabel
                      label="Select input"
                      addPlaceholder
                      autocomplete="new-password"
                      className="mt-3"
                      inputAfter={<Icons className="password-icon" icon="eye-fill" />}
                      inputProps={{
                        value: '',
                        onChange: () => {},
                      }}
                      options={stateOptions}
                      placeholder="Select input placeholder"
                      variant="material"
                    />
                    <Switches
                      withLabel
                      label="Switches input"
                      className="mt-3"
                      inputProps={{
                        value: switchValue,
                        onChange: () => { setSwitchValue(!switchValue); },
                      }}
                      options={stateOptions}
                      placeholder="Select input placeholder"
                      variant="material"
                      inverse
                    />
                    <CheckBoxInputWithLabel
                      withLabel
                      label="CheckBox input"
                      className="mt-3"
                      inputProps={{
                        value: switchValue,
                        onChange: () => { setSwitchValue(!switchValue); },
                      }}
                      options={stateOptions}
                      placeholder="Select input placeholder"
                      variant="material"
                      inverse
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
          <Col>
            <div className="frame">
              <div className="f4 p-3">Small Buttons</div>
              <Container className="components-table g-0 px-3 pb-3">
                <Row>
                  <Col>
                    <Button variant="primary" className="w-100">
                      <Icons width={16} height={16} customIcon icon="arrow-back-2" className="button-icons" />
                      Button
                      <Icons width={16} height={16} customIcon icon="arrow-forward-2" className="button-icons" />
                    </Button>
                    <Button variant="primary" className="mt-3 w-100 active">
                      <Icons width={16} height={16} customIcon icon="arrow-back-2" className="button-icons" />
                      Button
                      <Icons width={16} height={16} customIcon icon="arrow-forward-2" className="button-icons" />
                    </Button>
                    <Button disabled variant="primary" className="mt-3 w-100">
                      <Icons width={16} height={16} customIcon icon="arrow-back-2" className="button-icons" />
                      Button
                      <Icons width={16} height={16} customIcon icon="arrow-forward-2" className="button-icons" />
                    </Button>
                  </Col>
                  <Col>
                    <Button variant="secondary" className="w-100" onClick={permissionDeniedHandler}>
                      <Icons width={16} height={16} customIcon icon="arrow-back-2" className="button-icons" />
                      Button 1
                      <Icons width={16} height={16} customIcon icon="arrow-forward-2" className="button-icons" />
                    </Button>
                    <Button variant="secondary" className="mt-3 w-100 active">
                      <Icons width={16} height={16} customIcon icon="arrow-back-2" className="button-icons" />
                      Button 2
                      <Icons width={16} height={16} customIcon icon="arrow-forward-2" className="button-icons" />
                    </Button>
                    <Button disabled variant="secondary" className="mt-3 w-100">
                      <Icons width={16} height={16} customIcon icon="arrow-back-2" className="button-icons" />
                      Button 3
                      <Icons width={16} height={16} customIcon icon="arrow-forward-2" className="button-icons" />
                    </Button>
                  </Col>
                  <Col>
                    <Button variant="link" className="w-100">
                      <Icons width={16} height={16} customIcon icon="arrow-back-2" className="button-icons" />
                      Button
                      <Icons width={16} height={16} customIcon icon="arrow-forward-2" className="button-icons" />
                    </Button>
                    <Button variant="link" className="mt-3 w-100 active">
                      <Icons width={16} height={16} customIcon icon="arrow-back-2" className="button-icons" />
                      Button
                      <Icons width={16} height={16} customIcon icon="arrow-forward-2" className="button-icons" />
                    </Button>
                    <Button disabled variant="link" className="mt-3 w-100">
                      <Icons width={16} height={16} customIcon icon="arrow-back-2" className="button-icons" />
                      Button
                      <Icons width={16} height={16} customIcon icon="arrow-forward-2" className="button-icons" />
                    </Button>
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
